export default __webpack_public_path__ + "static/media/Ballroll_00377.8c6f1914.png";